import { Heading, Text } from '@acb_devel/design-system';
import { Button } from '@acb_devel/design-system';
import type { Event } from '@services/events';
import { printEventDate } from '@utils/date';
import { CircleIcon } from '@acb_devel/design-system';

import styles from './ActiveEventCard.module.scss';

export function ActiveEventCard({
  event,
  onEdit,
  onDelete,
}: {
  event: Event;
  onEdit: (event: Event) => void;
  onDelete: (event: Event) => void;
}) {
  return (
    <div className={styles.activeEventCard}>
      <div className={styles.activeEventCard__header}>
        <Text variant="body-2" className={styles.activeEventCard__date}>
          {printEventDate(event.startEvent, event.endEvent)}
        </Text>
        <Text variant="body-1" className={styles.activeEventCard__title}>
          {event.fullName}
        </Text>
        <Heading
          as="p"
          variant="subhead"
          className={styles.activeEventCard__status}
        >
          {event.openForRegistration ? (
            <CircleIcon
              className={styles.activeEventCard__greenCircle}
              width="8"
              height="8"
            />
          ) : (
            <CircleIcon
              className={styles.activeEventCard__redCircle}
              width="8"
              height="8"
            />
          )}{' '}
          Inscripciones
        </Heading>
      </div>
      <div className={styles.activeEventCard__options}>
        <Button
          size="md"
          variant="flat"
          upperCase={false}
          onClick={() => onEdit(event)}
        >
          Editar
        </Button>
        <Button
          size="md"
          variant="outline"
          upperCase={false}
          onClick={() => onDelete(event)}
        >
          Borrar
        </Button>
      </div>
    </div>
  );
}
